const socketSubToGetRewind = (socket, handler) => {
  // following line(s) should be removed in UiKit
  // socket.on('getRewind', handler);
  socket.on("rewind_changed", handler);
};

const socketSubToGetCurrentTime = (socket, handler) => {
  // following line(s) should be removed in UiKit
  socket.on("getCurrentTime", handler);
};

const socketUnSubFromGetRewind = (socket, handler) => {
  // following line(s) should be removed in UiKit
  // socket.off('getRewind', handler);
  socket.off("rewind_changed", handler);
};

const socketUnSubFromGetCurrentTime = (socket, handler) => {
  // following line(s) should be removed in UiKit
  socket.off("getCurrentTime", handler);
};

const secondToPixel = (second, seekbarMax, seekbarWidth) => second / (seekbarMax / seekbarWidth);

const pixelToPercentage = (pixel, seekbarWidth) => `${100 - ((seekbarWidth - pixel) / seekbarWidth) * 100}%`;

const pixelToSecond = (pixel, seekbarMax, seekbarWidth) => Math.floor((pixel / seekbarWidth) * parseInt(seekbarMax, 10));

const timeToPercentage = (time, seekbarMax, seekbarWidth) => pixelToPercentage(secondToPixel(time, seekbarMax, seekbarWidth), seekbarWidth);

const formatTime = (ms) => new Date(ms).toISOString().substr(11, 8);

export {
  // handleChange,
  // calculateTimeAndOffset,
  // getScreens,
  // submitSkipRange,
  // updateSkipRange,
  secondToPixel,
  pixelToPercentage,
  timeToPercentage,
  pixelToSecond,
  formatTime,
  socketSubToGetRewind,
  socketSubToGetCurrentTime,
  socketUnSubFromGetRewind,
  socketUnSubFromGetCurrentTime,
};
